<template>

  <div class="navigation--section" @click="setMenuActive(false)">
    <template v-for="menu in items">

      <h4 :key="menu.name" class="navigation__item--heading">{{ $t(menu.title) }}</h4>

      <template v-for="item in menu.subitems">
        <template
          v-if="typeof item.permission === 'undefined' || (typeof item.permission === 'string' && $can(menuRoute, item.permission)) || (typeof item.permission === 'function' && item.permission())">
          <template v-if="item.permission === modulePayment">
            <router-link class="navigation__item"
                         v-if="typeof item.to !== 'undefined' && $store.getters['auth/user'].is_company_user === true"
                         :to="item.to" :key="item.name">
              <i :class="'icon--' + item.icon"></i> {{ $t(item.title) }}
            </router-link>
          </template>
          <template v-else>
            <router-link class="navigation__item"
                         :class="{'bold navigation__item--alert' : item.badgeCount > 0}"
                         v-if="typeof item.to !== 'undefined'" :to="item.to" :key="item.name">
              <i :class="'icon--' + item.icon"></i> {{ $t(item.title) }}
              <span v-if="typeof item.badge !== 'undefined' && item.badge()" class="badge">
                {{ item.badgeCount() }}
              </span>
            </router-link>
          </template>
        </template>
      </template>

    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { MENU_ROUTE_PERMISSION, MODULES } from '@/constants'

export default {
  name: 'MenuGroup',
  props: ['title', 'menuitems'],
  data () {
    return {
      items: this.menuitems
    }
  },
  computed: {
    menuRoute () {
      return MENU_ROUTE_PERMISSION
    },
    modulePayment () {
      return MODULES.PAYMENT
    }
  },
  methods: {
    ...mapActions('menu', [
      'setMenuActive'
    ]),
    closeMenu () {
      this.$emit('close-menu', true)
    },
    execFunction (menu, $event) {
      menu.fn(this, $event)
    }
  }
}
</script>
